export default __webpack_public_path__ + "54c1e0748bd9448b39f40acce64cd167.png";